import defualtLolaTechHttpErrorsLang from "../data/lang/lola-tech-http-errors.lang";
import { ErrorCode } from "../interface/API/apiError.interface";

export function isErrorCode(key: string): key is ErrorCode {
    return key in defualtLolaTechHttpErrorsLang;
}

/**
 * Convert string to ErrorCode, if the string is not defined in the system return GENERAL_ERROR
 * @param key - the string to convert
 * @returns ErrorCode - if the key is not defined in the system return GENERAL_ERROR
 */
export function convertStrToErrorCode(key: string): ErrorCode {

    if (!key || !isErrorCode(key)) {

        console.log('Received error code is not defined in the system, \
            return general error message. Received error code:', key);

        return 'GENERAL_ERROR';
    }

    return key;
}